import { defineMessages } from 'react-intl';

const messages = defineMessages({
  fieldsetDefault: { id: 'Default', defaultMessage: 'Default' },
  title: { id: 'Title', defaultMessage: 'Titolo' },
  cardStyle: { id: 'Card Style', defaultMessage: 'Stile della card' },
  simpleCard: { id: 'Simple Card', defaultMessage: 'Card semplice' },
  imageCard: { id: 'Image Card', defaultMessage: 'Card con immagine' },
  maxResults: { id: 'Max Results', defaultMessage: 'Numero massimo di risultati' },
  feedUrl: { id: 'Feed URL', defaultMessage: 'URL del Feed RSS' },
  buttonText: { id: 'Button Text', defaultMessage: 'Testo del bottone' },
  buttonLink: { id: 'Button Link', defaultMessage: 'Link del bottone' },
  showPublishDate: { id: 'Show Publish Date', defaultMessage: 'Visualizza la data di pubblicazione' },
  showFourthColumn: { id: 'Show Fourth column', defaultMessage: 'Visualizza su quattro colonne' },
});

const rssSchema = (props) => {
  const { intl } = props;

  return {
    title: 'RSS Feed Block',
    required: ['feedUrl'], // Solo l'URL del feed è obbligatorio
    fieldsets: [
      {
        id: 'default',
        title: intl.formatMessage(messages.fieldsetDefault),
        fields: ['title', 'cardStyle', 'maxResults', 'feedUrl', 'showPublishDate', 'showFourthColumn', 'buttonText', 'buttonLink'],
      },
    ],
    properties: {
      title: {
        title: intl.formatMessage(messages.title),
        type: 'string',
        widget: 'text',
        default: 'Notizie dal Feed RSS',
      },
      cardStyle: {
        title: intl.formatMessage(messages.cardStyle),
        widget: 'select',
        choices: [
          ['simple', intl.formatMessage(messages.simpleCard)],
          ['image', intl.formatMessage(messages.imageCard)],
        ],
        default: 'simple',
      },
      maxResults: {
        title: intl.formatMessage(messages.maxResults),
        type: 'number',
        minimum: 1,
        default: 5,
      },
      feedUrl: {
        title: intl.formatMessage(messages.feedUrl),
        type: 'string',
        widget: 'url',
        default: '',
      },
      showPublishDate: {
        title: intl.formatMessage(messages.showPublishDate),
        type: 'boolean',
        default: true,
      },
      showFourthColumn: {
        title: intl.formatMessage(messages.showFourthColumn),
        type: 'boolean',
        default: false,
      },
      buttonText: {
        title: intl.formatMessage(messages.buttonText),
        type: 'string',
        widget: 'text',
        default: 'Clicca qui',
      },
      buttonLink: {
        title: intl.formatMessage(messages.buttonLink),
        description: 'spiegazione su come usarlo',
        widget: 'url', // Cambiato a url per supportare link esterni e interni
        default: '/',
      },
    },
  };
};

export default rssSchema;